// سكربت أزرار نافذة/صفحة التقرير — يعمل على الحاسوب والجوال وداخل تطبيق Capacitor.
import { fitScript } from "./reportFit";

export const reportScript = (pdfUrl, fileName, labels = {}) => {
  return `${fitScript()}<script>
var PDF_URL = ${JSON.stringify(pdfUrl || "")};
var PDF_NAME = ${JSON.stringify(`${fileName || "report"}.pdf`)};
var NATIVE = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
var EMBEDDED = false;
try { EMBEDDED = !!(window.parent && window.parent !== window); } catch (e) { EMBEDDED = true; }
var TOUCH = NATIVE || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '')
  || (navigator.maxTouchPoints || 0) > 1;
function markMobile() {
  if (!document.body) return;
  if (TOUCH || EMBEDDED) document.body.classList.add('mobile-report');
  if (EMBEDDED) document.body.classList.add('embedded');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markMobile);
else markMobile();
// تسخين فوري وموحّد: نبدأ تحميل الـ PDF فور فتح الصفحة ونحتفظ بوعد واحد مشترك،
// فإن ضغط المستخدم قبل اكتماله ننتظر نفس الطلب (بلا طلب جديد) ليكون الفتح فورياً.
var PDF_FILE = null;
function warmPdf(tries) {
  tries = tries || 0;
  if (!PDF_URL) return Promise.resolve(null);
  if (PDF_FILE) return Promise.resolve(PDF_FILE);
  var again = function () {
    return tries < 12
      ? new Promise(function (r) { setTimeout(r, 1200); }).then(function () { return warmPdf(tries + 1); })
      : null;
  };
  return fetch(PDF_URL, { credentials: 'omit' })
    .then(function (r) { return r.ok ? r.blob() : null; })
    .then(function (b) {
      if (b && b.size > 1500) { PDF_FILE = new File([b], PDF_NAME, { type: 'application/pdf' }); return PDF_FILE; }
      return again();
    })
    .catch(function () { return again(); });
}
warmPdf();
function openExternal(u) {
  try { var w = window.open(u, '_blank'); if (!w) window.location.href = u; }
  catch (e) { window.location.href = u; }
}
function reportClose() {
  if (EMBEDDED) { try { window.parent.postMessage({ helcooReport: 'close' }, '*'); return; } catch (e) {} }
  try { if (window.opener && !window.opener.closed) { window.close(); return; } } catch (e) {}
  if (window.history.length > 1) { window.history.back(); return; }
  window.location.href = '/';
}
function reportPrint() {
  if (NATIVE && PDF_URL) { openExternal(PDF_URL); return; }
  try { window.print(); } catch (e) { if (PDF_URL) openExternal(PDF_URL); }
}
function pdfBusy(on) {
  var b = document.querySelector('.btn-pdf');
  if (!b) return;
  if (on) { b.dataset.t = b.dataset.t || b.textContent; b.textContent = '⏳'; b.disabled = true; }
  else { if (b.dataset.t) b.textContent = b.dataset.t; b.disabled = false; }
}
function saveBlobFile(blob) {
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url; a.download = PDF_NAME; a.rel = 'noopener';
  document.body.appendChild(a); a.click();
  setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 4000);
}
async function downloadReportPdf() {
  if (!PDF_URL) return;
  if (PDF_FILE) { saveBlobFile(PDF_FILE); return; }
  pdfBusy(true);
  try {
    var f = await warmPdf();
    if (f) saveBlobFile(f);
    else window.location.href = PDF_URL;
  } catch (e) { window.location.href = PDF_URL; }
  finally { pdfBusy(false); }
}
async function shareReportPdf() {
  if (!PDF_URL) return;
  // الحاسوب: نفتح نافذة المشاركة (Web Share). الاسم الإنجليزي يصل صحيحاً؛ والعربي قد تعرضه بعض الأهداف رموزاً (خلل Chrome/واتساب).
  var f = PDF_FILE;
  if (!f) { pdfBusy(true); try { f = await warmPdf(); } catch (e) {} finally { pdfBusy(false); } }
  try {
    if (f && navigator.canShare && navigator.canShare({ files: [f] })) {
      navigator.share({ files: [f] }).catch(function () {});
      return;
    }
    if (navigator.share) { navigator.share({ url: PDF_URL }).catch(function () {}); return; }
  } catch (e) {}
  window.location.href = PDF_URL;
}
</script>`;
};
